import React from "react"
import Layout from "../components/styling/layout"
import { graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import styled from "styled-components"

const StyledImprintContainer = styled.div`
  padding-top: 100px;
  padding-bottom: 100px;
`

const ImprintPage = ({ data }) => (
  <Layout>
    <StyledImprintContainer>
      <MDXRenderer>
        {data.privacy.nodes[0].body}
      </MDXRenderer>
    </StyledImprintContainer>
  </Layout>
)

export default ImprintPage

export const pageQuery = graphql`
  {
    privacy: allMdx(filter: {fileAbsolutePath: {regex: "/(imprint)/"}}) {
      nodes {
        body
      }
    }
  }
`
